/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Recipient_Updated_ToastInputs */

const en_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event recipient updated successfully`)
};

const fr_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destinataire de l'evenement mis a jour avec succes`)
};

const de_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisempfänger erfolgreich aktualisiert`)
};

const it_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il destinatario dell'evento è stato aggiornato correttamente`)
};

const ru_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получатель события успешно обновлен.`)
};

const es_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El destinatario del evento se actualizó correctamente`)
};

const zh_cn2_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件接收人已成功更新`)
};

const ja_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの受信者が正常に更新されました`)
};

const hi_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट प्राप्तकर्ता को सफलतापूर्वक अपडेट कर दिया गया है।`)
};

const pt_pt2_speakers_recipient_updated_toast = /** @type {(inputs: Speakers_Recipient_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O destinatário do evento foi atualizado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Event recipient updated successfully" |
*
* @param {Speakers_Recipient_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_recipient_updated_toast = /** @type {((inputs?: Speakers_Recipient_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Recipient_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_recipient_updated_toast(inputs)
	if (locale === "de") return de_speakers_recipient_updated_toast(inputs)
	if (locale === "it") return it_speakers_recipient_updated_toast(inputs)
	if (locale === "ru") return ru_speakers_recipient_updated_toast(inputs)
	if (locale === "es") return es_speakers_recipient_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_recipient_updated_toast(inputs)
	if (locale === "ja") return ja_speakers_recipient_updated_toast(inputs)
	if (locale === "hi") return hi_speakers_recipient_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_recipient_updated_toast(inputs)
	return en_speakers_recipient_updated_toast(inputs)
});